import { useState } from "preact/hooks";
import { createContext } from "preact/compat";
const SnackbarContext = createContext();

export function SnackbarProvider({ children }) {
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");
	const [snackBarMessageDetails, setSnackBarMessageDetails] = useState("");
    const [showMeButton, setShowMeButton] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

	return (
        <SnackbarContext.Provider value={{
            snackBarOpen,
            setSnackBarOpen,
            snackBarMessage,
            setSnackBarMessage,
            showMeButton,
            setShowMeButton,
            timeoutId,
            setTimeoutId,
			snackBarMessageDetails,
			setSnackBarMessageDetails
        }}>
            {children}
        </SnackbarContext.Provider>
    );
}
export default SnackbarContext;
